<template>
  <div class="float-popup">
    <div class="float-popup-content">
      <div class="float-popup-header">
        <a href="./" target="_blank" class="logo"></a>
        <img v-if="storeData" :src="storeData.computed_logo" alt="logo" class="float-popup-logo">
      </div>
      <div class="float-popup-title" v-if="storeData">
        <span class="float-popup-title-highlight">{{storeData.cashback_max}}{{storeData.cashback_max_currency}} cashback</span>
        and <span class="float-popup-title-highlight">{{storeData.offers_count}} deals</span> found for {{storeData.host.replace('*.', '')}}!&nbsp;
      </div>
      <div class="float-popup-btn" v-if="storeData">
        <router-link class="btn-main thanks-btn"
                     target="_blank"
                     :to="{name: 'Loader', query: {
                               url: '#/?store=' + storeData.id,
                               title: storeData.title,
                               icon: storeData.icon,
                             }}" @click="sendEventCheckMore">
          See deals for {{storeData.host.replace('*.', '')}}
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.50021H16M16 9.50021L7.29028 0.790527M16 9.50021L7.29028 18.2099" stroke="white"
                  stroke-width="2"/>
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>


import {performRequest} from "@/api";
import {MAIN_API_URL, reportEvent} from "@/utils";

export default {
  name: 'FloatPopup',
  data: function () {
    return {
      storeData: null,
    }
  },
  methods: {
    sendEventCheckMore() {
      reportEvent('floating', {
        action: 'click_check_more'
      })
    }
  },
  mounted() {
    const storeId = this.$route.query.store

    if (storeId) {
      performRequest(
          `${MAIN_API_URL}get_store_by_id?id=${storeId}`,
          {
            method: 'POST'
          }
      ).then(res => {
        this.storeData = res.data.store
      })
    }
  }
}
</script>

<style lang="scss">

.float-popup {
  padding: 30px;
  min-height: 100vh;

  @media all and (min-width: 600px){
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .logo {
    display: inline-block;
  }

  &-title {
    font-size: 28px;
    margin-bottom: 36px;

    &-highlight {
      font-weight: 700;
      color: #00C6A2;
    }
  }

  &-logo {
    height: 30px;
  }

  &-btn {
    margin-top: 20px;

    .btn-main {
      padding: 18px 20px;
    }

    svg {
      margin-left: 12px;
    }
  }
}

</style>
